import { fetchUsers, unwrapThunk } from '@op/services'
import type { AppStore } from '../types'

export const usersResolver = async (store: AppStore) => {
	await unwrapThunk(store.dispatch(fetchUsers()))
}
